module.exports = __webpack_public_path__ + "img/66f.8c6520aa.png";